import FormInputComponent from "@via/components/inputs/form-input-component";
import SelectComponent from "@via/components/select/select.tsx";
import { EditProcessGroupOptions } from "@via/pages/projects/pipelines/workflow/utils/constants.tsx";
import { requiredValidation } from "@via/utils/form-validators";
import { SelectOption } from "@via/utils/interfaces.tsx";
import { useState } from "react";
import { useForm } from "react-hook-form";

export default function ManageMenuGroupModal({
  action,
  onCancel,
  menuGroups,
  onSubmit,
  menuGroup,
}) {
  const [selectedMenuGroup, setSelectedMenuGroup] = useState<SelectOption>(
    menuGroup ?? null
  );

  const handleMenuGroupUpdate = selected => {
    setSelectedMenuGroup(selected);
  };

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      menuGroup: selectedMenuGroup?.value ?? "",
      name: "",
    },
  });

  const onSubmitForm = handleSubmit(data => {
    if (action === EditProcessGroupOptions.CreateMenuGroup) {
      onSubmit(data?.name || "");
    } else {
      onSubmit(data);
    }
  });

  return (
    <div className="max-w-[500px]">
      <form
        onSubmit={e => {
          e.preventDefault();
          onSubmitForm(e);
        }}>
        {action === EditProcessGroupOptions.CreateMenuGroup ? (
          <div>
            <div className="modal-header">
              <h3 className="mb-4 text-lg font-medium leading-6 text-gray-900">
                Create Menu Group
              </h3>
            </div>
            <FormInputComponent
              control={control}
              name="name"
              label="Menu Group Name"
              placeholder="Enter Menu Group Name"
              validations={requiredValidation("Menu Group Name")}
              showRequiredField
            />
            <div className="modal-footer flex justify-end space-x-2 mt-4">
              <button
                type="button"
                className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                onClick={() => onCancel()}>
                Cancel
              </button>
              <button
                type="submit"
                className="ml-4 inline-flex justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                Submit
              </button>
            </div>
          </div>
        ) : action === EditProcessGroupOptions.EditMenuGroup ? (
          <div>
            <div className="modal-header">
              <h3 className="mb-4 text-lg font-medium leading-6 text-gray-900">
                Edit Menu Group
              </h3>
            </div>
            <label className="mb-2 block text-sm font-medium text-gray-900">
              Choose a Menu Group to Edit{" "}
              <span className="text-red-400">*</span>
            </label>
            <div className="my-2">
              <SelectComponent
                control={control}
                name="menuGroup"
                rules={requiredValidation("Menu Group")}
                value={selectedMenuGroup}
                enableClear={false}
                options={menuGroups}
                onChange={handleMenuGroupUpdate}
                placeholder={"Select a Menu Group to Edit"}
              />
              {errors.menuGroup && (
                <span className="text-xs text-rose-500">
                  {errors.menuGroup.message}
                </span>
              )}
            </div>
            <FormInputComponent
              control={control}
              name="name"
              label="New Menu Group Name"
              placeholder="Enter New Menu Group Name"
              validations={requiredValidation("New Menu Group Name")}
              showRequiredField
            />
            <div className="modal-footer flex justify-end space-x-2 mt-4">
              <button
                type="button"
                className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                onClick={() => onCancel()}>
                Cancel
              </button>
              <button
                type="submit"
                className="ml-4 inline-flex justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                Submit
              </button>
            </div>
          </div>
        ) : action === EditProcessGroupOptions.DeleteMenuGroup ? (
          <div>
            <div className="modal-header">
              <h3 className="text-lg font-medium leading-6 text-gray-900">
                Delete Menu Group
              </h3>
              <p className="pt-1 text-xs text-gray-500">
                Select a Menu Group below and choose Submit in order to delete.
                Menu Groups with associated Processes cannot be deleted.
              </p>
            </div>
            <div className="my-4">
              <SelectComponent
                control={control}
                name="menuGroup"
                rules={requiredValidation("Menu Group")}
                value={selectedMenuGroup}
                enableClear={false}
                options={menuGroups}
                onChange={handleMenuGroupUpdate}
                placeholder={"Select a Menu Group"}
              />
              {errors.menuGroup && (
                <span className="text-xs text-rose-500">
                  {errors.menuGroup.message}
                </span>
              )}
            </div>
            <div className="modal-footer flex justify-end space-x-2">
              <button
                type="button"
                className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                onClick={() => onCancel()}>
                Cancel
              </button>
              <button
                type="submit"
                className="ml-4 inline-flex justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                Submit
              </button>
            </div>
          </div>
        ) : (
          <></>
        )}
      </form>
    </div>
  );
}
